<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="370"
            id="createJobDialog">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ header }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="this.$vuetify.lang.t('$vuetify.jobModal.jobName')"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.name">
                        </v-text-field>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        {{ $vuetify.lang.t('$vuetify.jobModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'JobFormModal',

    props: {
        mode: {
            type: String,
            default: null
        },

        updateBranchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                name: ''
            },
            // phoneNumberMask: '',
            // inputRules: [
            //     v => this.$validator.hasValue(v, this.trans.jobModal.thisFieldIsRequired),
            //     v => this.$validator.lengthNotExceed(v, 255, this.trans.jobModal.thisFieldIsExceededCharacters)
            // ],
            // phoneRules: [
            //     v => this.$validator.lengthExactly(v, 11, this.trans.jobModal.incorrectPhoneNubmer)
            // ],
            nationalTelCode: '+66',
            errors: []
        }
    },

    directives: {
        mask
    },

    computed: {
        header () {
            if (this.mode === 'create') {
                return this.$vuetify.lang.t('$vuetify.jobModal.createJob')
            } else if (this.mode === 'update') {
                return this.$vuetify.lang.t('$vuetify.jobModal.updateJob')
            }
            return ''
        }
    },

    methods: {
        closeModal () {
            this.clearForm()
            this.$refs.form.resetValidation()
            this.$emit('close-modal')
            this.dialog = false
        },

        clearForm () {
            this.form = {
                name: ''
            }
            this.phoneNumberMask = ''
            this.errors = []
        },

        cleanForm () {
            const keys = ['name']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.cleanForm()

            if (this.mode === 'create') {
                await this.createBranch()
            } else if (this.mode === 'update') {
                await this.updateBranch()
            }
        },

        async createBranch () {
            this.$store.dispatch('setLoading', true)
            // this.form.contact_number = `${this.nationalTelCode} ${this.phoneNumberMask}`
            const res = await this.axios.post('job/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.JobModal.congratulation,
                    text: this.trans.JobModal.jobIsCreated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.JobModal.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateBranch () {
            this.$store.dispatch('setLoading', true)
            this.form.contact_number = `${this.nationalTelCode} ${this.phoneNumberMask}`
            const res = await this.axios.put(`job/edit/${this.updateBranchId}`, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.trans.JobModal.congratulation,
                    text: this.trans.JobModal.jobIsUpdated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.JobModal.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async getBranch (updateBranchId) {
            const res = await this.axios.get(`job/get/${updateBranchId}`)
            if (res && res.data && res.data.status === 'ok') {
                const data = res.data.data
                this.form.name = data.name
            }
        }
    },

    mounted () {
        this.registerLang({
            JobFormModal: [
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'incorrectPhoneNubmer',
                'congratulation',
                'jobIsCreated',
                'jobIsUpdated',
                'errorMessage'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
            } else if (newValue === 'update') {
                await this.getBranch(this.updateBranchId)
            }
        },
        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
